import(/* webpackMode: "eager", webpackExports: ["LoaderAtoms"] */ "/vercel/path0/src/components/loaders/loader-atoms.tsx");
